module.exports = __webpack_public_path__ + "img/ICONI_DT.cd267cb5.png";